module.exports = __webpack_public_path__ + "static/media/speaker-lectern-hacker-ai.3bed122b.jpeg";